import { default as module } from './AbstractModule';
import { shuffle } from '../utils/array'

export default class extends module {
    constructor(m) {
        super(m);

        this.delay = 2000

        this.pairs = shuffle(JSON.parse(this.getData('pairs')))
        this.first = this.$('first')
        this.second = this.$('second')
    }

    init() {
        this.cpt = 0
        this.interval = setInterval(() => {
            this.first.innerText = this.pairs[this.cpt % this.pairs.length].first
            this.second.innerText = this.pairs[this.cpt % this.pairs.length].second
            this.cpt++
        }, this.delay)
    }

    destroy() {
        clearInterval(this.interval)
    }
}
